<template>
    <div>
        <div class="container container-mob" >
            <b-button variant="btn" @click="$router.go(-1)" v-b-tooltip.hover title="Назад">
                <img width="40px" src="/static/images/icons/left-arrow.svg">
            </b-button>
            <div class="text-center pb-3" style="width: 90%; float: right;">
                <h1 class="section-head">{{school['name_'+selectedLocale.suffix.toLowerCase()]}}</h1>
            </div>
        </div>
        <div class="container pb-5">
            <div class="row">
                <div class="text-justify w-100">
                    <img class="inner_news_image" :src="(photos.length) ? '/static/uploads/'+photos[0].photo : '/static/images/no_image.jpg'">
                    <p v-html="school['body_' + selectedLocale.suffix.toLowerCase()]"></p>
                </div>
            </div>
                <div style="display: block" class="realized_images">
                    <gallery :images="images" :index="index" @close="index = null"></gallery>
                <vueper-slides class="no-shadow"  :visible-slides="4" slide-multiple :slide-ratio="1/4" :dragging-distance="200" :breakpoints="{ 800: { visibleSlides: 2 } }">
                    <vueper-slide v-for="(item, imageIndex)  in images" :key="item.id"  >
                        <div slot="slideContent"  @click="index = imageIndex" class="realized_img">
                            <b-img :src="item" fluid alt="Responsive image"></b-img>
                        </div>
                    </vueper-slide>
                </vueper-slides>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {getRealizedId} from '../api/index'
    import {VueperSlides, VueperSlide} from 'vueperslides'
    import 'vueperslides/dist/vueperslides.css'
    import VueGallery from 'vue-gallery';
    export default {
        name: 'realized-schools',
        components: {VueperSlides, VueperSlide, 'gallery': VueGallery},
        data() {
            return {
                school: {},
                photos: [],
                index: null,
                images: []
            }
        },
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                getRealizedId(  this.$route.params.id).then(res => {
                    this.school = (res.data.data.length) ? res.data.data[0] : {}
                    this.photos = res.data.images
                    res.data.images.forEach(val => {
                        this.images.push('/static/uploads/'+val.photo)
                    })
                })
            }
        }
    }
</script>

<style>
.inner_news_image {
    float: left;
    width: 100%;
    margin: 0 20px 10px 0;
    height: 480px;
}
    .realized_images .vueperslides__parallax-wrapper {
        padding-bottom: 20% !important;
    }
    .blueimp-gallery a {
        color: white !important;
    }
    .realized_img  {
        width: 268px;
        height: 178px;
    }
    .realized_img img {
        width: 100%;
        height: 100%;
        vertical-align: center;
    }
.container-mob {
    padding-top: 100px;
    display: flex;
}
</style>
